import styled from 'styled-components/native';

export const Image = styled.ImageBackground`
  width: 15rem;
  height: 8.44rem;
  margin: 0rem 1.5rem 0.5rem 0rem;
  border-radius: 10px;
  overflow: hidden;
`;

export const GridImage = styled.ImageBackground`
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
`;

export const LockedContainer = styled.View`
  justify-content: flex-end;
  align-items: flex-end;
  flex: 1;
  padding: 0.3rem;
`;

// Mesmo selo branco dos módulos (CategoryItem/ViewLock).
export const LockBadge = styled.View`
  background-color: white;
  padding: 3px;
  border-radius: 10px;
`;
